
import { UNIT, mainColor } from '../../constants/theme';
export const styles = ({

    paperStyle: {
        boxShadow: `1px 3px 5px #ccc`
    },

    fee: {
        top: -UNIT * 0.8125
    },
    headerFee: {
        fontSize: UNIT * 0.8125,
        color: mainColor.colorBlack
    },
    checkboxStyle: {
        marginTop: -UNIT * 0.5
    }
});
